import React from "react";
import { Link } from "react-router-dom";
import { FaTrash } from "react-icons/fa";
import { useModifyProdContext } from '../context/modifyprod_context';
import { useState } from "react";
import { useProfFilterContext } from "../context/prof_filter_context";



const ProfessionalRow = ({
  uid,
  name,
  contact_person,
  email,
  plan,
  joined,
  status,
}) => {
  
  const { deleteProduct } = useModifyProdContext();
  const [showConfirm,setShowConfirm] = useState(false);
  const {reloadData} = useProfFilterContext();

  const handleDelete = async() =>{
    try{
      await deleteProduct(uid,plan);
      reloadData();
      setShowConfirm(false);
    }
    catch(err){
      console.error('delete failed:'.err)
    }
  }
  return (
    <>
    <tr key={uid}>
      <td>{name}</td>
      <td>{contact_person}</td>
      <td>{email}</td>
      <td>{plan}</td>
      <td>
        <Link key={uid} to={`/prodedit/${uid}`} className="btn-large">
          Edit
        </Link>
      </td>
      <td>
        <FaTrash
          size={18}
          color="red"
          style={{ cursor: "pointer" }}
          onClick={() => setShowConfirm(true)}
        />
      </td>
    </tr>
    {showConfirm && (
          <div className="popup-overlay">
          <div className="popup-box">
            <h3>Confirm Delete</h3>
            <p>Are you sure you want to delete this professional?</p>
            <div className="popup-actions">
              <button className="btn-yes" onClick={handleDelete}>
                Yes
              </button>
              <button className="btn-cancel" onClick={() => setShowConfirm(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
  )}
          </>
  );
};

export default ProfessionalRow;
